import React from "react";
import AuthPageLayout from "@src/components/widgets/AuthPageLayout";
import styles from "./ClinicPendingPage.module.scss";

export default function ClinicPendingPage(): React.JSX.Element {
  return (
    <AuthPageLayout>
      <div className={styles.card}>
        <div className={styles.copy}>
          <h1 className={styles.title}>Welcome to VetGetRX</h1>
          <p className={styles.body}>
            We&rsquo;ll reach out to you at your clinic as soon as your account
            is ready.
          </p>
        </div>
      </div>
    </AuthPageLayout>
  );
}
